import api from "@/plugins/api/EntryPoint";

export default {
  async getPaymentHistory(params, callBackFn) {
    await api.post(`history/payments`, params, callBackFn);
  },
};
